// WHIT-494: the search forms' rules, pure (no DOM, no React) so
// `node --test web/utils/searchFormRules.test.js` can load them.

// What the flight form still needs, in the order the fields sit, or null
// when it can search. Search used to do nothing at all without a destination,
// and ran Budapest → Budapest into "We could not find any flights".
/**
 * @param {{ fromDestination?: { cityCode?: string } | null, toDestination?: { cityCode?: string } | null, fromDate?: number | null }} search
 * @returns {'from' | 'to' | 'sameAirport' | 'dateFrom' | null}
 */
const flightSearchProblem = ({ fromDestination, toDestination, fromDate }) => {
  if (!fromDestination) return 'from';
  if (!toDestination) return 'to';
  if (
    fromDestination.cityCode &&
    fromDestination.cityCode === toDestination.cityCode
  )
    return 'sameAirport';
  if (!fromDate) return 'dateFrom';
  return null;
};

// The sentence under the form for each problem, flight or package
// (missingSearchField in utils/packageSearch.js). A key of the translation
// files.
const SEARCH_PROBLEM_MESSAGES = {
  from: 'search_problem_from',
  to: 'search_problem_to',
  sameAirport: 'search_problem_same_airport',
  dateFrom: 'search_problem_date_from',
  dateTo: 'search_problem_date_to',
  childAges: 'search_problem_child_ages',
};
const searchProblemMessage = problem =>
  (problem && SEARCH_PROBLEM_MESSAGES[problem]) || null;

// The flight passenger picker's limits: at most 9 seats (adults and
// children), at least one adult, and no more infants than adults, who hold
// them. A button that cannot change the count is disabled instead of doing
// nothing when pressed.
const MAX_SEATED_PASSENGERS = 9;
/**
 * @param {{ adults: number, children: number, infants: number }} passengers
 * @param {'adults' | 'children' | 'infants'} type
 * @param {1 | -1} step
 */
const canChangePassengers = (passengers, type, step) => {
  const { adults, children, infants } = passengers;
  if (step === 1) {
    if (type === 'infants') return infants < adults;
    return adults + children < MAX_SEATED_PASSENGERS;
  }
  // Removing an adult may not leave an infant without a lap.
  if (type === 'adults') return adults > 1 && adults > infants;
  return passengers[type] > 0;
};

const passengerTotal = ({ adults, children, infants }) =>
  adults + children + infants;

module.exports = {
  flightSearchProblem,
  SEARCH_PROBLEM_MESSAGES,
  searchProblemMessage,
  MAX_SEATED_PASSENGERS,
  canChangePassengers,
  passengerTotal,
};
